import React, { useEffect, useState } from 'react';
import { isInteger } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

import { CenteredLoader } from 'clipsal-cortex-ui/src/components/CenteredLoader';

import { useParamBackUrl } from '../../common/hooks/use-param-back-url';
import { mapTariffApiToForm } from './tariff-helpers';
import { useTariffs } from './tariffApi';
import { useTariffFormContext } from './useTariffFormContext';

export function TariffSetupRoutes() {
  const { getValues, reset } = useTariffFormContext();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { tariffId } = useParams<{ tariffId: string }>();
  const { isLoading, tariffs } = useTariffs();
  const [isLoaded, setIsLoaded] = useState(false);
  const { t } = useTranslation();
  const backURL = useParamBackUrl('../../home?direction=back');

  useEffect(() => {
    // once we have tariffs, we can check if we need to redirect
    if (!isLoading) {
      const { id } = getValues();
      const paramTariffId = Number(tariffId);
      const isValidTariffId = isInteger(paramTariffId);

      // When direct url is passed, update the form with the tariff details
      if (isValidTariffId && id !== paramTariffId) {
        const tariff = tariffs.find((t) => t.id === Number(paramTariffId));
        if (tariff) reset(mapTariffApiToForm(tariff));

        // if somehow tariff id is messed up, redirect back home to tariff list
      } else if (!isValidTariffId && tariffId !== 'new') {
        navigate(`../home`);
      } else if (tariffId === 'new') {
        const searchParams = new URLSearchParams(search);
        if (!searchParams.get('direction')) searchParams.set('direction', 'forward');
        if (!searchParams.get('backURL')) searchParams.set('backURL', backURL);

        // return to home page for new tariffs and preserve entry-point params
        if (pathname.endsWith('/new')) {
          navigate(`home?${searchParams.toString()}`, { replace: true });
        }
      }

      setIsLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return !isLoaded || isLoading ? <CenteredLoader text={`${t('Common.loading')}...`} minHeight={'50vh'} /> : <Outlet />;
}
